<template>
    <div class="select-banner-cover">
        <div class="header">
            <div class="title">
                <span class="main">Добавление продукта. </span>
                <span class="sub">Выбор обложки</span>
            </div>
        </div>

        <div class="middle">
            <ChoiceImages v-model="selectedCover"
                          :images="dicts.backgrounds" />
        </div>

        <div class="footer two-sided">
            <div class="left">
                <button class="only-icon back" @click="onBack">
                    <IconArrowLeft class="icon" />
                </button>
            </div>
            <div class="right">
                <input class="ghost"
                       type="button"
                       value="Отмена"
                       @click="$emit('close')"
                />
                <input :disabled="!selectedCover || loading"
                       :value="createButtonText"
                       class="primary create"
                       type="button"
                       @click="onNext" />
            </div>
        </div>

    </div>
</template>

<script>

import ChoiceImages from '@/common/page_comp/ChoiceImages/ChoiceImages.vue';
import { MODERATE_CARD } from '@/common/rights.js';
import { hasRights } from '@/common/session.js';


export default {
    name: 'SelectBannerCover',
    components: { ChoiceImages },
    props: {
        value: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        dicts: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedCover: null,
        };
    },
    computed: {
        moderateCard() {
            return hasRights([ MODERATE_CARD ]);
        },
        createButtonText() {
            if (this.moderateCard)
                return 'Добавить';

            return 'Добавить черновик';
        },
    },
    created() {
        this.selectedCover = this.value.background;
        if (!this.selectedCover) {
            this.selectedCover = this.dicts.backgrounds[0] ?? null;
        }
    },
    methods: {
        onNext() {
            if (!this.selectedCover)
                return;

            this.$emit('next', {
                background: this.selectedCover,
            });
        },
        onBack() {
            this.$emit('back', {
                background: this.selectedCover,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.select-banner-cover {

}
</style>
